import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ButtonWithArrow = ({ text, onClick, className }) => (
  <button onClick={onClick} style={{ padding: '16px', textAlign: 'left' }} className={classnames('btn btn-arrow flex space-between middle text-wrap', className)}>
    <div>{text}</div>
    <img className="img-responsive hidden-xs" src="https://assets.peerspace.com/right-arrow-grey.svg?v=rb" />
  </button>
);

ButtonWithArrow.propTypes = {
  text: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default ButtonWithArrow;
